import startCase from "lodash/startCase";

import { tenantConfig } from "@tenant-config";
import { type DealTrackingSubtotalsByStageItem } from "@vega-api/generated/types/dealTrackingSubtotalsByStageItem";
import { AnalyticCard } from "@vega-core/components/MetricCard/AnalyticCard";
import { Skeleton } from "@vega-core/components/shadcn/skeleton";
import { type Stage, Stages } from "@vega-core/components/Stages/Stages";
import { m } from "@vega-core/paraglide/messages";

const DEFAULT_COLOR = "bg-neutral-500-light";

const LOADING_PLACEHOLDERS = Array.from({ length: 5 }, (_, index) => index);

// Used in CoInvestmentTrackingPage to transform the subtotals by stage query data
export const subtotalsByStageToStages = (
  items: DealTrackingSubtotalsByStageItem[],
): Stage[] =>
  items.map((item) => ({
    title: startCase(item.stage),
    value: String(item.count),
    color:
      tenantConfig.content.coInvestment?.dealStages[item.stage.toLowerCase()]
        ?.color ?? DEFAULT_COLOR,
  }));

type SubtotalsByStageProps = {
  stages?: Stage[];
  isLoading?: boolean;
};

export const SubtotalsByStage = ({
  stages = [],
  isLoading,
}: SubtotalsByStageProps) => {
  if (!isLoading && !stages.length) {
    return null;
  }

  return (
    <AnalyticCard
      canScreenShot
      dataTestId="subtotals-by-stage"
      isLoading={isLoading}
      title={m.coInvestments_tracking_subtotalsByStage()}
    >
      {isLoading ? (
        <div className="flex gap-4 pt-6">
          {LOADING_PLACEHOLDERS.map((id) => (
            <div className="flex-1 flex flex-col gap-2" key={id}>
              <Skeleton className="h-1 w-full" />
              <div className="p-4 flex flex-col gap-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-6 w-10" />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full min-w-0 pt-6">
          <Stages scrollable stages={stages} />
        </div>
      )}
    </AnalyticCard>
  );
};
